
import Hero from "../components/Hero";
import Features from "../components/Features";
import Partners from "../components/Partners";
import EmailForms from "../components/EmailForms";
import Footer from "../components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <Partners />
      <Features />
      <EmailForms />
      <Footer />
    </div>
  );
};

export default Index;
